import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { SectionLabel } from '../../design';
import { CONTACT_EMAIL, MKT } from './links';
import { MarketingLayout } from './MarketingLayout';
import './security.css';
import { AnalyticsEvent, ctaEvent } from '../../utils/analytics';
// Every statement here is backed by the server code (services/crypto.go, the per-user
// service-layer scoping and its isolation tests, the mail draft flow, services/claude_client.go).
const POINTS = [
    {
        k: '鍵',
        title: 'Auction logins and mailbox tokens are encrypted at rest',
        text: 'They’re stored with AES-256-GCM and used only to run your own searches and handle your own mail. Nobody else’s searches ever run on your agent account.'
    },
    {
        k: '分',
        title: 'Every account is isolated',
        text: 'Your cars, customers, costs and documents are kept apart from every other account, so another shop can’t see your bids or your margins.'
    },
    {
        k: '稿',
        title: 'Email is draft-first',
        text: 'Customer emails wait in your Outbox until you approve them, unless you switch on auto-send. You can disconnect your mailbox whenever you like, in the app or from your email provider’s side.'
    },
    {
        k: '読',
        title: 'What AI is used for',
        text: 'AI reads auction sheets and your documents, prices similar lots, checks matches against a customer’s criteria and writes listing blurbs. It runs on Anthropic’s Claude and only ever sees your account’s data, for your account.'
    }
];
export default function SecurityPage() {
    return /*#__PURE__*/ _jsx(MarketingLayout, {
        testid: Testids.app.marketing.securityRoot,
        children: /*#__PURE__*/ _jsxs("main", {
            className: "mk-security",
            children: [
                /*#__PURE__*/ _jsx(SectionLabel, {
                    k: "安全",
                    className: "mk-security__label",
                    children: "Security & privacy"
                }),
                /*#__PURE__*/ _jsx("h1", {
                    className: "mk-security__title",
                    children: "Your logins, mail and numbers stay yours."
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mk-security__intro",
                    children: "What we store, what we use it for and what we don’t do, in plain language."
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mk-security__list",
                    children: POINTS.map((p)=>/*#__PURE__*/ _jsxs("section", {
                            className: "mk-security__item",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "mk-security__k",
                                    children: p.k
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("h2", {
                                            className: "mk-security__heading",
                                            children: p.title
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "mk-security__text",
                                            children: p.text
                                        })
                                    ]
                                })
                            ]
                        }, p.k))
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: "mk-security__contact",
                    children: [
                        "Questions about security?",
                        ' ',
                        /*#__PURE__*/ _jsx("a", {
                            href: MKT.bookCall,
                            ...ctaEvent(AnalyticsEvent.ctaBookCall, 'security'),
                            children: "Book a call"
                        }),
                        ' ',
                        "or email ",
                        CONTACT_EMAIL,
                        "."
                    ]
                })
            ]
        })
    });
}
